import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { AlertItem, AlertListResponse, MarkAlertsAsResolvedDto } from '../../../api/models';
import {
  AlertControllerFindAllAlert$Params,
  AlertControllerFindOneAlert$Params,
  AlertControllerMarkAsResolved$Params,
  AlertControllerMarkAlertsAsResolved$Params,
} from '../../../api/functions';

export const alertActions = {
  // list
  loadAlertList: createAction('load/alert/load', props<AlertControllerFindAllAlert$Params>()),
  loadAlertListDone: createAction(
    'load/alert/done',
    props<{ state: ILoaderActionPayload; data?: AlertListResponse; request?: AlertControllerFindAllAlert$Params }>(),
  ),
  loadAlertListSetState: createAction('alert/load/state', props<{ state: ILoaderActionPayload }>()),
  // Restituisce un alert
  loadOneAlert: createAction('loadOne/alert/loadOne', props<AlertControllerFindOneAlert$Params>()),
  loadOneAlertDone: createAction('loadOne/alert/done', props<{ state: ILoaderActionPayload; data?: AlertItem }>()),
  //mark as resolved
  markAsResolved: createAction('mark-as-resoved/alert/load', props<AlertControllerMarkAsResolved$Params>()),
  markAsResolvedDone: createAction(
    'mark-as-resoved/alert/done',
    props<{ state: ILoaderActionPayload; data?: AlertItem; request?: AlertControllerFindAllAlert$Params }>(),
  ),
  markAsResolvedSetState: createAction('alert/mark-as-resoved/state', props<{ state: ILoaderActionPayload }>()),
  //mark multiple as resolved (batch mode)
  markAlertsAsResolved: createAction(
    'mark-as-resolved-batch/alert/load',
    props<AlertControllerMarkAlertsAsResolved$Params>(),
  ),
  markAlertsAsResolvedDone: createAction(
    'mark-as-resolved-batch/alert/done',
    props<{ state: ILoaderActionPayload; request?: MarkAlertsAsResolvedDto }>(),
  ),
  markAlertsAsResolvedSetState: createAction(
    'alert/mark-as-resolved-batch/state',
    props<{ state: ILoaderActionPayload }>(),
  ),
};
